import React from "react";
var __jsx = React.createElement;
import Image from "next/image";
/** Task type/label chip; Aira-generated tasks get a gradient background and the Aira logo. */
export function TaskLabel(_ref) {
  var label = _ref.label,
    isAira = _ref.isAira;
  return /*#__PURE__*/React.createElement("span", {
    title: label,
    "data-testid": isAira ? "task-label-aira" : "task-label",
    className: "inline-flex min-w-0 max-w-full items-center gap-1 rounded-sds-100 px-1.5 py-1 text-style-label-caps ".concat(isAira ? "bg-gradient-to-r from-aira-start/25 to-aira-end/25 text-sds-base-secondary" : "bg-sds-brand-tertiary text-sds-brand-default")
  }, isAira && /*#__PURE__*/React.createElement(Image, {
    src: "/assets/icons/aira-logo.svg",
    alt: "",
    width: 14,
    height: 14,
    className: "h-3.5 w-3.5 flex-shrink-0"
  }), /*#__PURE__*/React.createElement("span", {
    className: "truncate"
  }, label));
}